import React from "react";

import { Double, Repeat, Undo } from "src/shared/components/icons";
import { IconProps } from "./types";

export const Icon = (props: IconProps) => {
  let icon = null;

  switch (props.type) {
    case "double":
      icon = <Double />;
      break;
    case "repeat":
      icon = <Repeat />;
      break;
    case "undo":
      icon = <Undo />;
      break;
  }

  return icon;
};
